/* eslint-disable no-script-url */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../common/SvgIcon';
import cx from 'classnames';

import { isVMBusiness } from '../../utils/BrandUtils';

class InfoCards extends React.Component {
  constructor(props) {
    super(props);
    this.renderFinancialServicesInfoCard =
      this.renderFinancialServicesInfoCard.bind(this);
    this.getInfoCards = this.getInfoCards.bind(this);
  }

  renderFinancialServicesInfoCard(cardItem) {
    const { content, cardClicked } = this.props;
    const { BankUrl } = content;
    return (
      <div className="col-sm1-12 col-xl1-8">
        <div className="c-panel c-panel--featured">
          <h3 className="c-panel__heading">
            <a
              href={BankUrl}
              aria-haspopup="true"
              className="c-panel__link"
              onClick={(e) => {
                e.preventDefault();
                cardClicked(cardItem.id);
              }}
            >
              {cardItem.cardName}
            </a>
          </h3>

          <div className="c-panel__body">
            <div className="c-media">
              <div className="c-media__thumb">
                <img
                  src="../images/bow/FSCS_logo@1x.png"
                  srcSet="../images/bow/FSCS_logo@2x.png 2x"
                  alt=""
                />
              </div>

              <div className="c-media__body">
                <p>{cardItem.cardContent}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getInfoCards() {
    const { infoCardsItems = [], cardClicked } = this.props;

    return infoCardsItems.map((cardItem, index) => {
      const {
        id,
        iconClass,
        svgId,
        cardName,
        cardContent,
        vmFaqCardLink,
        vmFaqCardLinkSME,
      } = cardItem;

      const cardContentClassName = cx('c-panel__body', {
        'u-cursor-default': id === 'CALL_CONTENT',
      });
      const linkClassName = cx('c-panel__link', {
        'c-panel__link--before-none u-cursor-default': id === 'CALL_CONTENT',
      });
      const cardIcon = (
        <span className={iconClass} aria-hidden="true">
          {svgId !== null ? (
            <SvgIcon id={svgId} width="16px" height="16px" />
          ) : null}
        </span>
      );

      if (id === 'FINANCIAL_SERVICES') {
        return this.renderFinancialServicesInfoCard(cardItem);
      }
      return (
        <div
          className="col-sm1-12 col-xl1-8"
          style={id === 'CHAT' ? { display: 'block !important' } : null}
          key={`InfoCards_getInfoCards__${id}_${index}`}
        >
          <div className="c-panel c-panel--featured">
            <h3 className="c-panel__heading">
              {vmFaqCardLink ? (
                <a
                  href={isVMBusiness() ? vmFaqCardLinkSME : vmFaqCardLink}
                  target="_blank"
                  rel="noreferrer noopener"
                  className={linkClassName}
                >
                  {cardIcon}
                  {cardName}
                </a>
              ) : (
                <a
                  href="javascript:;"
                  className={linkClassName}
                  onClick={() => {
                    cardClicked(id);
                  }}
                >
                  {cardIcon}
                  {cardName}
                </a>
              )}
            </h3>
            <div className={cardContentClassName}>
              <p>{cardContent}</p>
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    return <div className="row">{this.getInfoCards()}</div>;
  }
}

InfoCards.propTypes = {
  infoCardsItems: PropTypes.array,
  cardClicked: PropTypes.func,
  content: PropTypes.object,
};

InfoCards.defaultProps = {
  infoCardsItems: [],
  onClick() {
    return null;
  },
};

export default InfoCards;
